export const formatMessage = (request) => {
  const newRequest = { ...request };
  if (newRequest.extraWind) {
    newRequest.extraWind = newRequest.extraWind.replace(/Wind ([0-9]+) mph or greater/, 'Wind $1+');
  }
  let message = `${request.wxMessagetype} `;

  // If there is an hour but no minutes selected, default to 00 minutes
  if (newRequest.wxTimeHour !== '') {
    newRequest.wxTimeMinutes = newRequest.wxTimeMinutes ? newRequest.wxTimeMinutes : '00';
  }

  // For non-net say until
  let prefix = "at";
  if (message.indexOf('Net') === -1 && message.indexOf('PSA') === -1) {
    prefix = "until";
  }
  
  message += newRequest.wxTimeHour !== ''
    ? `${prefix} ${String(newRequest.wxTimeHour).padStart(2, '0')}:${String(newRequest.wxTimeMinutes).padStart(2, '0')}. `
    : '';
  if (newRequest.wxRepeater.toLowerCase()) {
    message += newRequest.wxRepeater.toLowerCase() === 'no net' ? 'No Net ' : `Net activation on ${newRequest.wxRepeater}. `;
  }
  message += newRequest.extraWind ? `${newRequest.extraWind}. ` : '';
  message += newRequest.extraHail ? `${newRequest.extraHail}. ` : '';
  message += newRequest.extraHazard ? `${newRequest.extraHazard}. ` : '';
  message += newRequest.extraText ? `${newRequest.extraText}` : '';

  return message;
};

export const formatTimeStamp = (timestamp) => {
  const dateObject = new Date(timestamp);

  // JavaScript months are 0 based;
  const month = dateObject.getMonth() + 1;
  const date = dateObject.getDate();
  const year = dateObject.getFullYear();
  const hours = String(dateObject.getHours()).padStart(2, '0');
  const minutes = String(dateObject.getMinutes()).padStart(2, '0');
  const seconds = String(dateObject.getSeconds()).padStart(2, '0');

  return `${month}/${date}/${year} ${hours}:${minutes}:${seconds}`;
};
